export const tokens = {
  colors: {
    // New spec-compliant tokens
    bg: 'var(--color-bg)',
    bgMuted: 'var(--color-bg-muted)',
    fg: 'var(--color-fg)',
    fgMuted: 'var(--color-fg-muted)',
    fgSubtle: 'var(--color-fg-subtle)',
    border: 'var(--color-border)',
    black: 'var(--color-black)',
    white: 'var(--color-white)',
    accent: 'var(--color-accent)',
    accentLight: 'var(--color-accent-light)',
    accentHover: 'var(--color-accent-hover)',
    accentText: 'var(--color-accent-text)',
    accentTextHover: 'var(--color-accent-text-hover)',

    // Project card, a dark surface on a light section. Scoped so the rest of the
    // light-only site is untouched.
    cardFrom: 'var(--color-card-from)',
    cardTo: 'var(--color-card-to)',
    cardFg: 'var(--color-card-fg)',
    cardFgMuted: 'var(--color-card-fg-muted)',
    cardBorder: 'var(--color-card-border)',
    cardFrame: 'var(--color-card-frame)',

    // Contribution heatmap, empty day first
  contributions: [
    'var(--contribution-0)',
    'var(--contribution-1)',
    'var(--contribution-2)',
    'var(--contribution-3)',
    'var(--contribution-4)',
  ],

  // Brand gradients, one pair per contact card
    brandEmailFrom: 'var(--brand-email-from)',
    brandEmailTo: 'var(--brand-email-to)',
    brandGithubFrom: 'var(--brand-github-from)',
    brandGithubTo: 'var(--brand-github-to)',
    brandLinkedinFrom: 'var(--brand-linkedin-from)',
    brandLinkedinTo: 'var(--brand-linkedin-to)',

    // Semantic aliases (new)
    textPrimary: 'var(--color-text-primary)',
    textSecondary: 'var(--color-text-secondary)',
    textTertiary: 'var(--color-text-tertiary)',
    background: 'var(--color-background)',
    backgroundMuted: 'var(--color-background-muted)',
    borderDefault: 'var(--color-border-default)',
    interactive: 'var(--color-interactive)',
    interactiveHover: 'var(--color-interactive-hover)',

    // Backward compatibility aliases (old token names). The error/errorBg/success/successBg
    // aliases were removed: nothing referenced them, and they all resolved to the accent
    // colour, so tokens.colors.success would have painted a success message blue.
    primary: 'var(--color-accent)',
    primaryHover: 'var(--color-accent-hover)',
    primaryLight: 'var(--color-accent-light)',
    textMuted: 'var(--color-text-tertiary)',
    bgAccent: 'var(--color-bg-muted)',
    borderSubtle: 'var(--color-border)',
    focus: 'var(--color-accent)',
  },
  space: {
    0: 'var(--space-0)',
    1: 'var(--space-1)',
    2: 'var(--space-2)',
    3: 'var(--space-3)',
    4: 'var(--space-4)',
    5: 'var(--space-5)',
    6: 'var(--space-6)',
    8: 'var(--space-8)',
    10: 'var(--space-10)',
    12: 'var(--space-12)',
    16: 'var(--space-16)',
    20: 'var(--space-20)',
    24: 'var(--space-24)',
    32: 'var(--space-32)',
    40: 'var(--space-40)',
  }, 
  fonts: {
    sans: 'var(--font-sans)',
    mono: 'var(--font-mono)',
  },
  fontSizes: {
    // New spec-compliant tokens
    displayHero: 'var(--text-display-hero)',
    displaySection: 'var(--text-display-section)',
    displayProject: 'var(--text-display-project)',
    // specs/020. The contact band's email, which is the band's subject rather than a heading.
    displayEmail: 'var(--text-display-email)',
    largeSubtitle: 'var(--text-large-subtitle)',
    body: 'var(--text-body)',
    secondary: 'var(--text-secondary)',
    label: 'var(--text-label)',

    // Backward compatibility aliases
    xs: 'var(--text-label)',
    sm: 'var(--text-secondary)',
    base: 'var(--text-body)',
    lg: 'var(--text-large-subtitle)',
    xl: 'var(--text-display-project)',
    '2xl': 'var(--text-display-section)',
    '3xl': 'var(--text-display-hero)',
    '4xl': 'var(--text-display-hero)',
    '5xl': 'var(--text-display-hero)',
    '6xl': 'var(--text-display-hero)',
    'display-sm': 'var(--text-display-hero)',
    'display-md': 'var(--text-display-hero)',
    'display-lg': 'var(--text-display-hero)',
  },
  fontWeights: {
    normal: 'var(--font-weight-normal)',
    medium: 'var(--font-weight-medium)',
    semibold: 'var(--font-weight-semibold)',
    bold: 'var(--font-weight-bold)',
  },
  lineHeights: {
    tight: 'var(--line-height-tight)',
    snug: 'var(--line-height-snug)',
    normal: 'var(--line-height-normal)',
    relaxed: 'var(--line-height-relaxed)',
    display: 'var(--line-height-display)',
  },
  radii: {
    none: 'var(--radius-none)',
    sm: 'var(--radius-sm)',
    md: 'var(--radius-md)',
    lg: 'var(--radius-lg)',
    xl: 'var(--radius-xl)',
    '2xl': 'var(--radius-2xl)',
    full: 'var(--radius-full)',
  },
  shadows: {
    xs: 'var(--shadow-xs)',
    sm: 'var(--shadow-sm)',
    focus: 'var(--shadow-focus)',
    // Backward compatibility
    md: 'var(--shadow-sm)',
    lg: 'var(--shadow-sm)',
    xl: 'var(--shadow-sm)',
  },
  zIndices: {
    base: 0,
    dropdown: 100,
    sticky: 200,
    fixed: 300,
    modalBackdrop: 400,
    modal: 500,
    popover: 600,
    tooltip: 700,
    toast: 800,
  },
  containers: {
    sm: 'var(--container-sm)',
    md: 'var(--container-md)',
    lg: 'var(--container-lg)',
    xl: 'var(--container-xl)',
    '2xl': 'var(--container-2xl)',
  },
  transitions: {
    fast: 'var(--transition-fast)',
    normal: 'var(--transition-normal)',
    slow: 'var(--transition-slow)',
  },
  durations: {
    fast: 'var(--duration-fast)',
    normal: 'var(--duration-normal)',
    slow: 'var(--duration-slow)',
  },
  easings: {
    out: 'var(--ease-out)',
    inOut: 'var(--ease-in-out)',
    spring: 'var(--ease-spring)',
  },
};